<template>
    <div>
        <h1 id="card-header"  v-on:click="toggleCard()" @mouseover="teaseCard" @mouseout = "hideCard">
        <span class="material-icons" style="font-size:2rem; position:relative;bottom:-0.3rem;color:#3A4861;margin-right:0.5rem;">
            arrow_drop_down_circle
        </span>       
        {{this.title}}
            </h1>
            <div id="card-body" :style="'height:'+this.height">
                <div ref="content">
                    <div style="padding:1rem">
                        <slot></slot>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            default:"title",
            type:String
        }
    },
    data:function() {
        return{
        isOpen:false,
        height:"3rem",
        openHeight:"100px"}
    },
    methods:{
        toggleCard:function() {
            if(this.isOpen == true){
                this.height="0rem";
                this.isOpen=false;
            }else{
                this.height=this.openHeight;
                this.isOpen=true;
            }
        },
        teaseCard:function() {
            if(this.isOpen == false){
                this.height = "7rem"
            }
        },
        hideCard:function() {
            if(this.isOpen == false){
                this.height = "0rem"
            }
        }
    },
    mounted:function() {
            this.openHeight=this.$refs["content"].clientHeight+"px";
    }
}
</script>

<style scoped>
    #card-header{
        padding: 0.3rem;
        padding-left: 1rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 100;
        font-size:1.5rem;
        line-height: 1.2rem;

        margin: 0px;
        background-color:rgb(137, 172, 215);
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
        transition: 0.15s;
                transition-timing-function: ease;
    }
    #card-header:hover{
        text-decoration: underline;
        cursor: pointer;
        color:orange;
    }
    #card-body{
        overflow: hidden;
        border: solid;
        transition:  1s;
        transition-timing-function: ease;
        background-color:#F0F0F0;
        border-color:rgb(137, 172, 215);
        color:#767676;
    }
</style>